import gql from "graphql-tag";

// Staff props
const LeaveStaffProps = gql`
    fragment LeaveStaffProps on Staff {
        id
        surname
        first_name
        middle_name
        designation {
            id
            name
        }
    }
`;

const LeaveProps = gql`
    fragment LeaveProps on Leave {
        id
        authorized
        been_accessed
        datetime_out
        evaulate_leave
        leave_outcome
        clothing_desc
        contact_tel_number
        created_at
        status
        type {
            id
            name
        }
        mental_state_assessment_detail
        venue
        return_datetime
        photo_updated
        escorts {
            ...LeaveStaffProps
        }
        created_at
        plan_action
        author {
            ...LeaveStaffProps
        }
    }
    ${LeaveStaffProps}
`;

// LIST
const LIST = gql`
    query GET_LEAVES($id: ID!, $site: ID!) {
        GetAdmissionLeaves(id: $id) {
            docs {
                ...LeaveProps
            }
        }
        GetLeaveStatusList(site: $site) {
            docs {
                id
                name
            }
        }
        GetLeaveTypes(site: $site) {
            docs {
                id
                name
            }
        }
        GetStaffList(page: 1, limit: 2000) {
            docs {
                ...LeaveStaffProps
            }
        }
    }
    ${LeaveProps}
`;

// NEW LEAVE
const CREATE = gql`
    mutation CreateLeave($model: LeaveInput!) {
        CreateLeave(model: $model) {
            message
            doc {
                ...LeaveProps
            }
        }
    }
    ${LeaveProps}
`;

// UPDATE

const UPDATE = gql`
    mutation UpdateLeave($model: LeaveUpdateMiniInput!, $id: ID!) {
        UpdateBasicLeave(id: $id, update: $model) {
            message
            doc {
                ...LeaveProps
            }
        }
    }
    ${LeaveProps}
`;

export { LIST, CREATE, UPDATE };
